import React, { useEffect, useState } from 'react'
import AuthCardComponent from '../../components/login-card/auth-card.component'
import './auth.css';
import { Button, Form, Input, message } from 'antd';
import LilyButton from '../../components/button/lily-button';
import { useNavigate, useLocation } from 'react-router-dom';
import { REQUEST_OTP, VERIFY_OTP } from '../../api/URLs';
import portalAPI from '../../api/api';
import { useDispatch } from 'react-redux';
import { setAuthenticatedUser } from '../../stores/authenticated-user.store';
import { maskEmail } from '../../exports/util';
import { UpdateDefaultMethod } from '../../exports/services';

const OtpVerificationsPage = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { code, email, token } = location.state || {};
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [errors, setErrors] = useState({
        code: ''
    });
    const [codeLength, setCodeLength] = useState([]);
    const [count, setCount] = useState(60);
    const [key, setKey] = useState(0);
    const [accessToken, setAccessToken] = useState('');

    useEffect(() => {
        if (!token) return;
        setAccessToken(token);
    }, [token])

    useEffect(() => {
        setCount(60); // Reset count on key change

        const interval = setInterval(() => {
            setCount((prev) => {
                if (prev === 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [key]);

    const onChange = text => {
        let formattedValue = text;
        let validationError = '';

        // Update form field with formatted value
        form.setFieldsValue({ code: formattedValue });

        // Update error state
        setErrors((prev) => ({
            ...prev,
            code: validationError,
        }));
    };

    const onInput = value => {
        setCodeLength(value);
    };
    const sharedProps = {
        onChange,
        onInput,
    };

    const handleSubmit = async () => {
        setLoading(true)
        try {
            const values = await form.validateFields();

            await portalAPI.post(VERIFY_OTP, values, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        UpdateDefaultMethod(dispatch, res.data);
                        dispatch(setAuthenticatedUser(res.data));
                        navigate('/dashboard');
                    }
                }).catch((err) => {
                    let rsp = err.response;
                    message.error(rsp?.data?.message || 'Internal Server Error');
                })
        } catch (error) {
            message.error(`Failed to login Please try again.`);
        } finally {
            setLoading(false);
        }
    }

    const handleResendCode = async () => {
        setResendLoading(true);
        try {
            let rsp = await portalAPI.post(REQUEST_OTP, { email: email });
            if (rsp.status === 200) {
                setAccessToken(rsp?.data?.token);
                setKey((prev) => prev + 1);
                message.success("Resend Code Successfully")
            }
        } catch (err) {
            message.error("Failed to Resend Code");
        } finally {
            setResendLoading(false);
        }
    };

    return (
        <div className='auth-layout'>
            <AuthCardComponent
                title="Enter Code"
                description={`Enter the one-time passcode sent to ${email && maskEmail(email)} to access your account.`}
            >
                <div className='d-flex justify-content-center'>
                    <div className='d-flex flex-column align-items-center justify-content-evenly' style={{ height: '400px', width: 'fit-content' }}>
                        <Form
                            form={form}
                            name="access-card"
                            layout="vertical"
                            labelCol={{ span: 8 }}
                            initialValues={{
                                code: '',
                            }}
                        >
                            <Form.Item
                                name="code"
                                rules={[{ required: true }]}
                                validateStatus={errors.code ? 'error' : ''}
                                help={errors.code}
                                className='mb-3 custom-otp-input'
                            >
                                <Input.OTP size='large' length={6} formatter={str => str.toUpperCase()} {...sharedProps} onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault(); // Block non-numeric input
                                    }
                                }} />
                            </Form.Item>
                        </Form>
                        <div className='w-100 d-flex flex-column align-items-center gap-3'>
                            <LilyButton
                                text="Submit"
                                className='w-100'
                                size='large'
                                loading={loading}
                                disabled={codeLength.length < 6}
                                onClick={handleSubmit}
                            />
                            <Button className='resend-code-btn' disabled={count > 0} loading={resendLoading} onClick={handleResendCode} color="default" variant="link">
                                Resend Code {count !== 0 && `(${count}s)`}
                            </Button>
                        </div>
                    </div>
                </div>
            </AuthCardComponent>
        </div>
    )
}

export default OtpVerificationsPage